var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharpUpLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FFF4DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9202 11.3459C22.9645 11.34 22.997 11.3016 22.997 11.2572V9.88248C22.997 9.82927 22.9497 9.78492 22.8965 9.79379L19.8041 10.1959L20.2062 7.10347C20.2121 7.05026 20.1707 7.00296 20.1175 7.00296H18.7428C18.6984 7.00296 18.66 7.03548 18.6541 7.07982L18.2225 10.4028L12.8832 11.0946L13.4006 7.10052C13.4065 7.0473 13.3651 7 13.3119 7H11.9372C11.8928 7 11.8544 7.03252 11.8485 7.07687L11.3016 11.2956L7.07687 11.8455C7.03252 11.8514 7 11.8899 7 11.9342V13.3089C7 13.3622 7.0473 13.4065 7.10052 13.3976L11.0916 12.8803L10.3999 18.2195L7.07687 18.6511C7.03252 18.6571 7 18.6955 7 18.7398V20.1146C7 20.1678 7.0473 20.2121 7.10052 20.2033L10.1929 19.8012L9.79084 22.8936C9.78492 22.9468 9.82631 22.9941 9.87953 22.9941H11.2543C11.2986 22.9941 11.337 22.9616 11.3429 22.9172L11.7746 19.5942L17.1138 18.9024L16.5965 22.8936C16.5905 22.9468 16.6319 22.9941 16.6851 22.9941H18.0599C18.1042 22.9941 18.1426 22.9616 18.1486 22.9172L18.6955 18.6984L22.9143 18.1515C22.9586 18.1456 22.9911 18.1072 22.9911 18.0628V16.6881C22.9911 16.6349 22.9438 16.5905 22.8906 16.5994L18.8995 17.1168L19.5913 11.7775L22.9143 11.3459H22.9202ZM17.3208 17.3208L11.9815 18.0126L12.6733 12.6733L18.0126 11.9815L17.3208 17.3208Z",
    fill: "#CC962B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharpUpLock);
export default __webpack_public_path__ + "static/media/sharp_up_lock.1f89635537c27fbc7933aaa0bd24d359.svg";
export { ForwardRef as ReactComponent };